import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export var isObject = function (value) {
    return value !== null && (value === null || value === void 0 ? void 0 : value.constructor) === Object;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export var isFunction = function (value) {
    return typeof value === 'function';
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export var isBoolean = function (value) {
    return typeof value === 'boolean';
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export var isString = function (value) {
    return typeof value === 'string';
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export var isEmptyString = function (value) {
    return isString(value) && value.trim().length === 0;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export var isDate = function (value) {
    return Object.prototype.toString.call(value) === '[object Date]';
};
export var isReactElement = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
value) { return React.isValidElement(value); };
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export var isTruthy = function (value) {
    return Boolean(value) || value === 0;
};
